import { render, staticRenderFns } from "./PatientBase.vue?vue&type=template&id=4e87d6e0&"
import script from "./PatientBase.vue?vue&type=script&lang=ts&"
export * from "./PatientBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports